export default __webpack_public_path__ + "static/media/angbao-bonus-dewali.d92fbc94.webp";